module.exports = __webpack_public_path__ + "img/ENERGEM.53598b21.png";